const QUIZ_EMPTY_SLOT = `
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M5.30769 6.69231H0.692308C0.496154 6.69231 0.331769 6.62592 0.199154 6.49315C0.0663847 6.36038 0 6.19592 0 5.99977C0 5.80346 0.0663847 5.63908 0.199154 5.50662C0.331769 5.374 0.496154 5.30769 0.692308 5.30769H5.30769V0.692308C5.30769 0.496154 5.37408 0.331769 5.50685 0.199154C5.63962 0.0663847 5.80408 0 6.00023 0C6.19654 0 6.36092 0.0663847 6.49338 0.199154C6.626 0.331769 6.69231 0.496154 6.69231 0.692308V5.30769H11.3077C11.5038 5.30769 11.6682 5.37408 11.8008 5.50685C11.9336 5.63962 12 5.80408 12 6.00023C12 6.19654 11.9336 6.36092 11.8008 6.49338C11.6682 6.626 11.5038 6.69231 11.3077 6.69231H6.69231V11.3077C6.69231 11.5038 6.62592 11.6682 6.49315 11.8008C6.36038 11.9336 6.19592 12 5.99977 12C5.80346 12 5.63908 11.9336 5.50662 11.8008C5.374 11.6682 5.30769 11.5038 5.30769 11.3077V6.69231Z" fill="#C4B3A3"/>
    </svg>
  </span>
`;

class QuizStepVariant {
  constructor(container) {
    this.container = container;
    this.maxColors = 4;
    this.colorTitle = this.container.querySelector(
      '.quiz-color-options .quiz-select-title'
    );
    this.baseColorTitle =
      this.colorTitle?.textContent.trim() || '';
    this.selectedSlots = this.container.querySelector(
      '[data-selected-slots]'
    );
    this.counter = this.container.querySelector(
      '.selected-counter__current'
    );
    this.counterTarget = this.container.querySelector(
      '.selected-counter__target'
    );
    this.helper = this.container.querySelector(
      '[data-pack-helper]'
    );
    this.nextBtn = this.container.querySelector(
      '.quiz-next'
    );
    this.colorOptions = [
      ...this.container.querySelectorAll(
        '[data-color-option]'
      )
    ].map((option) => ({
      option,
      input: option.querySelector(
        '[data-color-quantity-input]'
      ),
      count: option.querySelector(
        '[data-color-count]'
      ),
      increaseBtn: option.querySelector(
        '[data-color-increase]'
      ),
      decreaseBtn: option.querySelector(
        '[data-color-decrease]'
      )
    }));

    this.initColorPackBuilder();
    this.initSizeGuidePopup();
    this.bindQuizEvents();
  }

  bindQuizEvents() {
    document.addEventListener(
      'quiz:pack-change',
      (event) => {
        this.updatePackQuantity(
          event.detail?.packQuantity
        );
      }
    );

    document.addEventListener(
      'quiz:step-change',
      (event) => {
        if (
          Number(event.detail?.step) ===
          Number(this.container.dataset.step)
        ) {
          this.updatePackQuantity(
            event.detail?.packQuantity
          );
        }
      }
    );
  }

  initColorPackBuilder() {
    if (!this.colorOptions.length) return;

    this.colorOptions.forEach(
      ({
        input,
        increaseBtn,
        decreaseBtn
      }) => {
        increaseBtn?.addEventListener(
          'click',
          () => {
            this.changeColorQuantity(
              input,
              1
            );
          }
        );

        decreaseBtn?.addEventListener(
          'click',
          () => {
            this.changeColorQuantity(
              input,
              -1
            );
          }
        );
      }
    );

    this.updatePackQuantity(
      this.getPackQuantity()
    );
  }

  getPackQuantity() {
    if (
      window.quizApp &&
      typeof window.quizApp
        .getPackQuantity ===
        'function'
    ) {
      const quizPackQuantity =
        Number(
          window.quizApp.getPackQuantity()
        );

      if (quizPackQuantity > 0) {
        return quizPackQuantity;
      }
    }

    const selectedPack = document.querySelector(
      'input[name="quiz-step-5"]:checked'
    );

    const match = selectedPack?.value
      ?.toString()
      .match(/(\d+)/);

    return Number(match?.[1] || 4);
  }

  updatePackQuantity(nextQuantity) {
    const parsedQuantity = Number(nextQuantity);

    this.maxColors =
      Number.isFinite(parsedQuantity) &&
      parsedQuantity > 0
        ? parsedQuantity
        : 4;

    this.normalizeSelections();
    this.updateColorHeading();
    this.renderSelectedColors();
  }

  normalizeSelections() {
    let remaining = this.maxColors;

    this.colorOptions.forEach(
      ({ input }) => {
        const currentValue = Math.max(
          0,
          Number(input?.value || 0)
        );
        const nextValue = Math.min(
          currentValue,
          remaining
        );

        input.value = nextValue;
        remaining -= nextValue;
      }
    );
  }

  updateColorHeading() {
    const pairLabel =
      this.maxColors === 1
        ? 'pair'
        : 'pairs';

    if (this.counterTarget) {
      this.counterTarget.textContent =
        this.maxColors;
    }

    if (this.helper) {
      this.helper.textContent = `Choose ${this.maxColors} ${pairLabel}. Repeat colors if you want multiples.`;
    }

    if (!this.colorTitle) return;

    if (/\d+/.test(this.baseColorTitle)) {
      this.colorTitle.textContent =
        this.baseColorTitle.replace(
          /\d+/,
          String(this.maxColors)
        );
      return;
    }

    this.colorTitle.textContent = `${this.baseColorTitle} (${this.maxColors} ${pairLabel})`;
  }

  changeColorQuantity(input, delta) {
    if (!input) return;

    const currentValue = Math.max(
      0,
      Number(input.value || 0)
    );

    if (
      delta > 0 &&
      this.getSelectedCount() >=
        this.maxColors
    ) {
      return;
    }

    input.value = Math.max(
      0,
      currentValue + delta
    );

    this.renderSelectedColors();
  }

  getSelectedCount() {
    return this.colorOptions.reduce(
      (total, { input }) =>
        total +
        Math.max(
          0,
          Number(input?.value || 0)
        ),
      0
    );
  }

  getSelectedColors() {
    return this.colorOptions.flatMap(
      ({ input }) => {
        const quantity = Math.max(
          0,
          Number(input?.value || 0)
        );

        if (!quantity) {
          return [];
        }

        return Array.from(
          { length: quantity },
          () => ({
            label: input.dataset.color,
            value: input.dataset.colorValue
          })
        );
      }
    );
  }

  renderSelectedColors() {
    const selectedColors =
      this.getSelectedColors();
    const totalSelected =
      selectedColors.length;

    if (this.selectedSlots) {
      const filledSlots = selectedColors.map(
        (color) => `
          <div class="selected-slot is-filled">
            <span
              class="selected-slot__color"
              style="background:${color.value};"
              title="${color.label}"
            ></span>
          </div>
        `
      );
      const emptySlots = Array.from(
        {
          length: Math.max(
            this.maxColors -
              totalSelected,
            0
          )
        },
        () => `
          <div class="selected-slot">
            ${QUIZ_EMPTY_SLOT}
          </div>
        `
      );

      this.selectedSlots.innerHTML = [
        ...filledSlots,
        ...emptySlots
      ].join('');
    }

    if (this.counter) {
      this.counter.textContent =
        totalSelected;
    }

    this.colorOptions.forEach(
      ({
        option,
        input,
        count,
        increaseBtn,
        decreaseBtn
      }) => {
        const quantity = Math.max(
          0,
          Number(input?.value || 0)
        );

        option.classList.toggle(
          'is-selected',
          quantity > 0
        );

        if (count) {
          count.textContent = quantity;
        }

        if (increaseBtn) {
          increaseBtn.disabled =
            totalSelected >=
            this.maxColors;
        }

        if (decreaseBtn) {
          decreaseBtn.disabled =
            quantity < 1;
        }
      }
    );

    if (this.nextBtn) {
      this.nextBtn.disabled =
        totalSelected !==
        this.maxColors;
    }
  }

  initSizeGuidePopup() {
    const trigger = this.container.querySelector(
      '[data-size-guide-trigger]'
    );

    const popup = this.container.querySelector(
      '[data-size-guide-popup]'
    );

    const closeBtn = this.container.querySelector(
      '[data-size-guide-close]'
    );

    const overlay = popup?.querySelector(
      '.size-guide-popup__overlay'
    );

    if (!trigger || !popup) return;

    trigger.addEventListener('click', () => {
      popup.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    const closePopup = () => {
      popup.classList.remove('active');
      document.body.style.overflow = '';
    };

    closeBtn?.addEventListener(
      'click',
      closePopup
    );

    overlay?.addEventListener(
      'click',
      closePopup
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape') {
          closePopup();
        }
      }
    );
  }
}

window.QuizStepVariant = QuizStepVariant;
document.addEventListener(
  'DOMContentLoaded',
  () => {
    document
      .querySelectorAll('.quiz-step-6')
      .forEach((container) => {
        new QuizStepVariant(container);
      });
  }
);
